/*
* class AppTools
*/

var AppTools = function() {

    /*
    * Env variables
    */
    let body        = document.body;
    let bezier      = 'cubic-bezier(.58,.01,.19,1)';
    let scrollList  = [];
    let chartList   = [];
    let listmarkers = [];
    let listmaps    = [];
    let windowheight;
    let windowWidth;
    let flagscreen;

    let options = {
        sitekey : '6LeGOoAUAAAAAF_FGlNYM71Az7p01IlRdHkeaP6G'
        // templateurl : ''
    };

    /*
    * Boutons des carousel
    */
    // var nextbtn = '<svg class="icon-big-arrow-r second"><use href="'+env.templateurl+'/dist/images/svg/svg.svg#big-arrow-r"></use></svg>';
    // var prevbtn = '<svg class="icon-big-arrow-l second"><use href="'+env.templateurl+'/dist/images/svg/svg.svg#big-arrow-l"></use></svg>';


    /*
    * Sizes grille (Inférieur à | Ex: ml = < 1600)
    */
    let sizeml = 1600;
    let sizems = 1280;
    let sizem  = 1099;
    let sizesm = 768;
    let sizes  = 426;

    /*
    * useragents
    */
    var deviceAgent = navigator.userAgent.toLowerCase(),
        agentID     = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        screentype;

    var ie          = /MSIE \d|Trident.*rv:/.test(navigator.userAgent);

    /*
    * Gestion events resize
    */

    var initresize = function() {

        // console.log('Resizing');
    
        windowheight = window.innerHeight
        windowWidth  = window.innerWidth//$(window).width()
    
        // $('.w-h').height(windowheight)
        // $('.w-m-h').css({'max-height':windowheight})
    
        // ms size
        if(windowWidth <= sizes){
    
            screentype = 's'
            agentID = true
    
            // controlRespSliders('kill')
            // controlRespSliders('s')
        }
        else if(windowWidth <= sizem){
    
            screentype = 'm'
            agentID = true
    
            // controlRespSliders('kill')
            // controlRespSliders('m')
        }
        else if(windowWidth <= sizems){
    
            screentype = 'ms'
    
            // controlRespSliders('kill')
            // controlRespSliders('ms')
        }
        else if(windowWidth <= sizeml){
    
            screentype = 'ml'
    
            // controlRespSliders('kill')
            // controlRespSliders('ml')
        }
        else{
    
            screentype = 'l'
            // controlRespSliders('kill')
        }
    
        // Lancement des modules
        // carousels()
        // tooltip()
        // initMap()
    }    


    /**
     * Front
     */

    var ajaxForm = function(id) 
    {
        
        let form = document.getElementById(id);

        form.addEventListener('submit', function(event){

            event.preventDefault();
            
            let form   = this;

            /**
             * Trait loader
             */
            
            let btn = form.querySelector('[type="submit"]');

            if( !btn.querySelector('.spinner') ) {
                let loader = document.createElement('div');
                loader.classList.add('spinner','black');
                btn.append(loader);
            }else{
                let loader = btn.querySelector('.spinner');
            }

            form.classList.add('loading');

            /**
             * Trait tel
             */
            
            let tel = form.querySelector('[name="tel"]');
            let val = tel.value.replace(/\s/g, "");
            tel.value = val;

            /**
             * Do request
             */

            let action  = form.getAttribute('action');
            let data    = new FormData(form);
            
            let request = new Promise(function (resolve, reject) {
                
                let xhr = new XMLHttpRequest();
                
                xhr.open('POST', action, true);
                xhr.responseType = 'json';
                xhr.onload = function () {
                    
                    if (this.status >= 200 && this.status < 300) {
                        let data;
                        let json = xhr.response;
                        resolve(json);
                    } else {
                        reject({
                            status: this.status,
                            statusText: xhr.statusText
                        });
                    }
                };
                xhr.onerror = function () {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                };

                
                if(!ie){
                    grecaptcha.ready(function() {
                        grecaptcha.execute(options.sitekey, {action: 'sendform'}).then(function(token) {
                            data.append('captcha', token);
                            xhr.send(data);
                        });
                    });
                }else{
                    data.append('nocaptcha', true);
                    xhr.send(data);
                }

            });

            /**
             * Trait request
             */

            request.then(function (response) {
                
                if(ie){
                    response = JSON.parse(response);
                }
                
                let errors = form.querySelectorAll('.error');

                [].forEach.call(errors, function(error) {
                    error.classList.remove('error');
                });

                let errmsg = form.querySelectorAll('.help-message');

                [].forEach.call(errmsg, function(error) {
                    error.remove();
                });

                if(response.status === 0){ 

                    [].forEach.call(response.errors, function(error) {
                        
                        let elem   = document.getElementById(error.id);
                        let parent = elem.closest(".field");

                        if(elem && parent)
                            parent.classList.add('error');

                        let msg = document.createElement('p');
                        msg.classList.add('help-message');
                        msg.appendChild(document.createTextNode(error.message));

                        parent.appendChild(msg);
                    });

                    form.classList.add('form-error');
                    form.classList.remove('loading');

                }else if (response.status === 1){

                    form.classList.add('success');
                    form.classList.remove('loading','form-error');

                    /**
                     * Track google event
                     */

                    track('LandingITL','Envoi formulaire ok');

                    /**
                     * Handle lead to google sheets
                     */

                    let req = new XMLHttpRequest();
                    req.open('GET', 'https://script.google.com/macros/s/AKfycbx6ogB8LVcyhiehDZqLAnNW-DuDPHLeH_JcbeeiDZBin1mYeerR/exec?'+response.datauri, true); 
                    req.send();
                }               
                
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({'event' : 'formSubmission', parameters : {action:action,data:response} });

            }).catch(function (err) {
                console.error('Error', err);
            });
        });
    }

    var scrollActions = function()
    {
        
        let links = document.querySelectorAll('a[href^="#"]');
        
        
        for (let index = 0; index < links.length; index++) {
            
            let anchor = links[index];
            anchor.addEventListener('click', function (event) {
                event.preventDefault();
                let target    = document.querySelector(anchor.getAttribute('href'));
                let bodyrect  = document.body.getBoundingClientRect();
                let targetpos = target.getBoundingClientRect();
                
                // window.scroll({
                //     top: targetpos.top - bodyrect.top - headbar.offsetHeight - 15, 
                //     behavior: 'smooth' 
                // });

                var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
                var options = {
                    "behavior": "smooth",
                    "left": 0,
                    "top":  targetpos.top - bodyrect.top - 15
                };

                if (isSmoothScrollSupported) {
                    window.scrollTo(options);
                } else if (window.jQuery && jQuery.scrollTo) {
                    $(window).scrollTo(options.top, options.left);
                } else {
                    window.scrollTo(options.left, options.top);
                }
            });
        }
    }

    /*
    * Tracking/event analytics
    */
    var track = function(category,label)
    {
        if ('ga' in window) {
            var tracker = ga.getAll()[0];
            if(tracker)
                tracker.send('event', category, label);
        }
    }

    /*
    * Check si touchevent
    */
    var touchEvents = function() {
        
        try {

            document.createEvent("TouchEvent");  
            return true;  

        } catch (e) {  
            
            return false;  
        }  
    }

    /*
    * Check si nav "mobile" sous entendu interface opti pour les select
    */
    var mobileBrowser = function() {
        
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        
        return check;
    }

    /*
    * Class compat css navigateurs
    */
    var cssCompatibility = function() {

        // flexbox
        var c      = " ", prefixFlex = 'flex -webkit-flex -ms-flexbox -moz-box -webkit-box'.split(' '), 
            elem   = document.createElement('b'), 
            mStyle = elem.style;

        try{
            for(var i = 0, len = prefixFlex.length; i < len; i++)
                c += ( (mStyle.display = prefixFlex[i]) && mStyle.display != prefixFlex[i] ) ? 'no-flex' :  'flex', (i = len);

        }catch(e){ 
            c += "no-flex";
        }

        document.documentElement.className =  c + 'box';
    }

    var isVisible = function(el) {

        let elpos     = el.getBoundingClientRect();
        let eltop     = elpos.top;
        let scrolltop = (window.scrollY) ? window.scrollY : window.pageYOffset;
            
        if( (scrolltop+(window.innerHeight)) >= eltop )
            return true;

        return false;
    }

    /*
    * lazyLoad images
    */
    var lazyloadimg = function()
    {
        let images  = document.querySelectorAll('img[data-src]');
        
        for (var i = 0; i < images.length; i++){
            let img = images[i];

            if(!img.classList.contains('loaded')){

                if(isVisible(img)){

                    img.setAttribute('src', img.getAttribute('data-src'));
                    img.onload = function() {
                        // img.removeAttribute('data-src');
                        if( img.getAttribute('data-adaptative') )
                            adaptativeimg(img)
                        
                        let parent = img.parentElement;

                        if(parent.classList.contains('back_image'))
                            parent.classList.add('loaded');

                        img.classList.add('loaded');
                    };
                    // console.log(images[i], isVisible(img))
                }
            }
        }
    }

    var lazyBackground = function()
    {
        let backs = document.querySelectorAll('[data-lazy-background]');
        for (var i = 0; i < backs.length; i++){
            let back = backs[i]; 

            if(!back.classList.contains('backloaded')){
                back.style.backgroundImage = 'url('+back.getAttribute('data-lazy-background')+')';
                let img = new Image();
                img.onload = function() {
                    back.classList.add('backloaded');
                };
                img.src = back.getAttribute('data-lazy-background');
            }
        }
    }
    
    // /*
    // * Auto adapt images
    // */
    // var adaptativeimg = function(el)
    // { 
    //     let images;

    //     if(el)
    //         images = [el];
    //     else
    //         images = document.querySelectorAll('img[data-adaptative]');
        
    //     for (var i = 0; i < images.length; i++) {

            
    //         let image     = images[i];
    //         let container = image.parentElement;
    //         let data      = image.dataset;

    //         // si image plus haute que son conteneur
    //         if( image.clientHeight > container.clientHeight && image.clientWidth === container.clientWidth ){

    //             let diff = ( image.clientHeight - container.clientHeight ) / 2;                
    //             image.style.transform = 'translateX(0px) translateY(-'+diff+'px)';
    //             image.style.maxWidth  = '100%';
    //             // console.log('image plus haute à centrer verticalement');
    //         }
    //         else if( image.clientHeight > container.clientHeight && image.clientWidth > container.clientWidth ){

    //             image.style.maxWidth  = '100%';
    //             image.style.height    = 'auto';

    //             let diff = ( image.clientHeight - container.clientHeight ) / 2;                
    //             image.style.transform = 'translateX(0px) translateY(-'+diff+'px)';
    //             // console.log('image plus grande que conteneur');

    //             if( image.clientHeight < container.clientHeight ){
                    
    //                 image.style.height    = '100%';
    //                 image.style.transform = 'translateY(0px)';

    //                 image.style.width    = 'auto';
    //                 image.style.maxWidth = 'none';
                    
    //                 let diff = ( image.clientWidth - container.clientWidth ) / 2;                
    //                 image.style.transform = 'translateY(0px) translateX(-'+diff+'px)';
    //                 // console.log('(second traitement) - image moins haute que le conteneur');
    //             }
    //         }
    //         else if( image.clientHeight < container.clientHeight && data.adaptative === 'cover' ){
    //             // console.log(image.clientWidth)
    //             image.style.height    = '100%';
    //             image.style.transform = 'translateY(0px)';

    //             image.style.width    = 'auto';
    //             image.style.maxWidth = 'none';

    //             let diff = ( image.clientWidth - container.clientWidth ) / 2;                
    //             image.style.transform = 'translateY(0px) translateX(-'+diff+'px)';
    //             // console.log('image moins haute que le conteneur');
    //             // console.log(image.clientWidth,diff)

    //             if( image.clientWidth < container.clientWidth ){
                    
    //                 image.style.height    = 'auto';

    //                 image.style.width    = '100%';
    //                 image.style.maxWidth = 'none';
                    
    //                 let diff = ( image.clientHeight - container.clientHeight ) / 2;                
    //                 image.style.transform = 'translateY(-'+diff+'px) translateX(0px)';
    //                 // console.log('(second traitement) - image moins large que le conteneur');
    //             }

    //         }
    //         else if( image.clientWidth < container.clientWidth && data.adaptative === 'cover' ){
                
    //             image.style.height    = 'auto';

    //             image.style.width    = '100%';
    //             image.style.maxWidth = 'none';
                
    //             let diff = ( image.clientHeight - container.clientHeight ) / 2;                
    //             image.style.transform = 'translateY(-'+diff+'px) translateY(0px)';
    //             // console.log('image moins large que le conteneur');
    //         }
    //         else if( image.clientWidth > image.clientHeight ){

    //             image.style.height    = '100%';
    //             image.style.transform = 'translateY(0px)';

    //             image.style.width    = 'auto';
    //             image.style.maxWidth = 'none';

    //             let diff = ( image.clientWidth - container.clientWidth ) / 2;                
    //             image.style.transform = 'translateY(0px) translateX(-'+diff+'px)';
    //             // console.log('image large');
    //         }
    //         else if( image.clientWidth === image.clientHeight ){

    //             // console.log('image carré');

    //             if( container.clientWidth > container.clientHeight ) {
    //                 // console.log('conteneur paysage');
    //                 image.style.width     = '100%';
    //                 image.style.transform = 'translateY(0px)';
    //                 image.style.height    = 'auto';
    //                 image.style.maxWidth  = 'none';
    //                 image.style.maxHeight = 'none';
    //                 let diff = ( image.clientHeight - container.clientHeight ) / 2;
    //                 image.style.transform = 'translateY(-'+diff+'px) translateX(0px)';
    //             }else{
    //                 // console.log('conteneur portrait');
    //                 image.style.height    = '100%';
    //                 image.style.transform = 'translateY(0px)';
    //                 image.style.width    = 'auto';
    //                 image.style.maxWidth = 'none';
    //                 let diff = ( image.clientWidth - container.clientWidth ) / 2;
    //                 image.style.transform = 'translateY(0px) translateX(-'+diff+'px)';
    //             }
    //         }
    //         else{
    //             image.style.transform = 'translateY(0px) translateX(0px)';
    //         }

    //         image.classList.add('traited');
    //         // items[i].style.height = h+'px';
    //     }
    // }
    

    return {

        /*
        * Main class initializer
        */
        init: function() {
            AppTools.initComponents();
        },

        /*
        * Initializes components
        */
        initComponents: function() {
            
            initresize()  
            // smoothscroll()
            cssCompatibility()
            scrollActions()
            // adaptativeimg()

            window.addEventListener('resize', function() {
                initresize()
                // refreshScrolls()
                // adaptativeimg()
            })

            
            if(ie){
                // console.log(env.templateurl+'/dist/js/module.svgie.js');
                // document.body.classList.add('ie')
                // var s = document.createElement('script');
                // s.setAttribute('src', env.templateurl+'/dist/js/module.svgie.js');
                // document.getElementsByTagName('body')[0].appendChild(s);

                // var cb = function() {
                //     var l  = document.createElement('link'); l.rel = 'stylesheet';
                //     l.href = '/css/fixie.css';
                //     var h  = document.getElementsByTagName('head')[0]; h.appendChild(l, h);
                // };
                // var raf = requestAnimationFrame || mozRequestAnimationFrame ||
                //     webkitRequestAnimationFrame || msRequestAnimationFrame;
                // if (raf) raf(cb);
                // else window.addEventListener('load', cb);
            }
        },

        isbot: function() {

            return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
        },

        isie: function() {
            return ie;
        },

        getTouchEvent: function() {
            return touchEvents()
        },

        getBody: function() {
            return $body;
        },

        getUserAgent: function() {
            return agentID;
        },

        getScreenType: function() {
            return screentype;
        },

        initLazyBackground: function() {
            lazyBackground();
        },

        initLazyloadimg: function() {
            lazyloadimg();
        },

        initCarousels: function() {
            carousels();
        },
        
        initCarouselsResp: function() {
            controlRespSliders();
        },

        // initAdaptativeImage: function() {
        //     adaptativeimg();
        // },

        initForm: function(id) {
            ajaxForm(id);
        },

        track:function(cat,label) {
            track(cat,label);
        }
    };

}();

/**
 * Polyfill closest
 */

if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1); 
        return null;
    };
}

if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

(function() {
    AppTools.init();
})();